export const formatGMTDate = date => {
  // day.month.year
  const dateArray = date.split('T')[0].split('-');
  const day = dateArray[2];
  const month = dateArray[1];
  const year = dateArray[0];

  return `${day}.${month}.${year}`;
};
